export default class CommServiceTokenModel {
  token!: string;

  apiUrl!: string;

  code!: string;
}
